import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSend: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconSend"><Path d="M12.7568 21.1941C13.0831 22.7171 15.2274 22.7951 15.6635 21.2998L20.235 5.6259C20.5666 4.48906 19.5119 3.43432 18.375 3.7659L2.70115 8.33745C1.20587 8.77357 1.28384 10.9178 2.80686 11.2442L10.0519 12.7967C10.6294 12.9204 11.0805 13.3715 11.2043 13.9491L12.7568 21.1941Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconSend;
